import type { BoumClaims } from '@moia-dev/moia-token-claims'
import { FromBoumWireClaims } from '@moia-dev/moia-token-claims'
import { createContext, useContext } from 'react'

export const RestrictedContext = createContext<BoumClaims>(
  FromBoumWireClaims({}, {}),
)

export const useBoumClaimsConsumer = () => {
  const permissions = useContext(RestrictedContext)

  return permissions
}
